import React from 'react';

import { Box } from '@chakra-ui/react';

import { PageHeading } from 'uiToolkitV1/Headings';

const CFHeader = () => (
  <Box bg="neutral.F5F7F9" boxShadow="0px 1px 4px #cfd7df;">
    <PageHeading title="My Feedback" />
  </Box>
);

export { CFHeader };
